
class PageSideMenu {
    constructor (theme, elem) {
        this.name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._box = elem.querySelector('[data-page-side-menu-box]')
        this._menu = elem.querySelector('[data-page-side-menu-inner]')
    }

    onInit () {
        if (window.innerWidth > 768 && this._box) {
            document.addEventListener('scroll', () => {
                this.onScroll()
            })
            this.onScroll()
        }
        const button = this._elem.querySelector('[data-page-side-menu-button]')
        if (button) {
            button.addEventListener('click', () => { this.toggleMenu() })
        }
        const items = this._elem.querySelectorAll('[data-page-side-menu-item]')
        if (items.length > 0) {
            for (let item of items) {
                item.addEventListener('click', () => { this.closeMenu() })
            }
        }
        document.body.addEventListener('click', (e) => { this.checkOuterClick(e) })
    }
    onScroll () {
        let top = this._elem.offsetTop
        let offset = 150
        let boxHeight = this._box.scrollHeight
        let mainHeight = this._elem.offsetHeight - 150
        if (mainHeight > boxHeight && window.innerWidth > 768) {
            if (scrollY + offset > top) {
                this._box.style.top = `${(scrollY + offset) - top}px`
            } else {
                this._box.style.top = '0px'
            }
            if (scrollY + offset + boxHeight > top + mainHeight && boxHeight < mainHeight) {
                this._box.style.top = `${(mainHeight) - boxHeight}px`
            }
        }
    }
    toggleMenu () {
        const button = this._elem.querySelector('[data-page-side-menu-button]')
        this._menu.classList.toggle('active')
        button.classList.toggle('openmenu')
    }
    openMenu () {
        const button = this._elem.querySelector('[data-page-side-menu-button]')
        this._menu.classList.add('active')
        button.classList.add('openmenu')
    }
    closeMenu () {
        const button = this._elem.querySelector('[data-page-side-menu-button]')
        this._menu.classList.remove('active')
        button.classList.remove('openmenu')
    }
    checkOuterClick (e) {
        if (window.innerWidth <= 768) {
            if (this._elem !== e.target && this._elem.contains(e.target)) {
            } else {
                this.closeMenu()
            }
        }
    }
}

export default PageSideMenu



// WEBPACK FOOTER //
// ./src/resources/scripts/components/PageSideMenu.js